import type { LocaleCode } from '@@fire-base/i18n'

export type LocalizedString = Partial<Record<LocaleCode, string>>

/**
 * Resolves a localized string from a locale-keyed record.
 * Tries the current locale first, then the configured fallback locale, then a default value.
 * Empty strings are treated as missing (falls through to next option).
 */
export function resolveLocalizedString(localizedString: LocalizedString | undefined | null, defaultValue = ''): string {
  if (!localizedString) {
    return defaultValue
  }
  const locale = useNuxtApp().$i18n.locale.value
  const fallbackLocale = useRuntimeConfig().public.fallbackLocaleCode
  return localizedString[locale as LocaleCode] || localizedString[fallbackLocale as LocaleCode] || defaultValue
}
